module.exports = __webpack_public_path__ + "static/img/p1-3-0.1c78267.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-3-0.png
// module id = oCxG
// module chunks = 0